import { useEffect, useRef } from 'react';

/**
 * Saves the currently focused element when `isOpen` becomes true,
 * and restores focus to it when `isOpen` becomes false.
 *
 * Use this for dialogs opened programmatically (via state) rather than
 * via a DialogTrigger, since tabster's built-in focus restoration
 * requires a trigger element as its target.
 */
export const useFocusRestore = (isOpen: boolean) => {
  const previousFocusRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (isOpen) {
      previousFocusRef.current = document.activeElement as HTMLElement;
    } else if (previousFocusRef.current) {
      const elementToFocus = previousFocusRef.current;
      previousFocusRef.current = null;
      requestAnimationFrame(() => {
        if (elementToFocus.isConnected) {
          elementToFocus.focus();
        }
      });
    }
  }, [isOpen]);
};
